import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { ObservedMetadataKeyDto } from '@/Domain/api/Action/dto/Action.dto';

export const useObservedMetadataKeys = () =>
  useQuery<ObservedMetadataKeyDto[]>({
    queryKey: [QueryKey.actions.basic.observed_metadata_keys],
  });
